import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Icon = styled.span`
  font-size: 2rem;
  color: #3d98b9;
`;
